// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linkFile {
  clear: both;
  color: #106a90;
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  margin: 0px;
  padding: 2px 5px;
  transition: all 0.3s;
}
.linkFile a {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
  width: 100%;
}
.linkFile:hover {
  background-color: #F5F5F5;
  border-radius: 3px;
}
.fileTitle {
  display: flex;
  clear: both;
  cursor: pointer;
  font-size: 12px;
  line-height: 12px;
  margin: 0;
  padding: 0;
  transition: all 0.3s;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  color: rgba(0, 0, 0, 0.45);
}
.fileName {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
}
.colFile {
  font-size: 18px;
  color: #106a90;
  width: 21px;
  height: 21px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
}
.colFile:hover {
  background: #106a90;
  border-radius: 3px;
  color: #ffffff;
}
.customFile {
  border-radius: 4px;
  max-height: 350px;
  overflow: overlay;
  box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);
}
.customFile .ant-dropdown-menu-title-content {
  flex: auto;
  max-width: 350px;
}
.customFile .ant-dropdown-menu-item,
.customFile .ant-dropdown-menu-submenu-title {
  padding: 2px 6px;
}
.customFile .ant-dropdown-menu {
  padding: 0;
}
.customFile .ant-dropdown-menu-title-content {
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/layers-tree/DropdownFile.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AACF;AATA;EAWM,qBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AACN;AACE;EACE,yBAAA;EACA,kBAAA;AACJ;AAIA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AAFF;AAKA;EACE,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AAHF;AAMA;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAKE;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;AAHJ;AAOA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,2CAAA;AALF;AACA;EAMI,UAAA;EACA,gBAAA;AAJJ;AAHA;;EAUI,gBAAA;AAHJ;AAPA;EAaI,UAAA;AAHJ;AAVA;EAiBI,gBAAA;AAJJ","sourcesContent":[".linkFile {\n  clear: both;\n  color: #106a90;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 22px;\n  margin: 0px;\n  padding: 2px 5px;\n  transition: all 0.3s;\n\n  a {\n      text-decoration: none;\n      color: inherit;\n      display: block;\n      height: 100%;\n      width: 100%;\n  }\n  &:hover {\n    background-color: #F5F5F5;\n    border-radius: 3px;\n  }\n}\n\n\n.fileTitle {\n  display: flex;\n  clear: both;\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 12px;\n  margin: 0;\n  padding: 0;\n  transition: all 0.3s;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  color: rgba(0,0,0,.45);\n}\n\n.fileName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  white-space: nowrap;\n}\n\n.colFile {\n  font-size: 18px;\n  color: #106a90;\n  width: 21px;\n  height: 21px;\n  display: flex;\n  justify-items: center;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background: #106a90;\n    border-radius: 3px;\n    color: #ffffff;\n  }\n}\n\n.customFile {\n  border-radius: 4px;\n  max-height: 350px;\n  overflow: overlay;\n  box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);\n  .ant-dropdown-menu-title-content {\n    flex: auto;\n    max-width: 350px;\n  }\n  .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {\n    padding: 2px 6px;\n  }\n  .ant-dropdown-menu {\n    padding: 0;\n  }\n\n  .ant-dropdown-menu-title-content {\n    overflow: hidden;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
